import { createApp } from 'vue';
import App from './App.vue';
import '@/assets/style/index.less';
import VueKonva from 'vue-konva';
import 'animate.css';
import { router } from './router';
import 'vant/es/toast/style';
import 'vant/es/notify/style';
const app = createApp(App);

// console.log(window);
const did = window.localStorage.getItem('did');
if (did) {
  window.android?.userInfo(
    JSON.stringify({
      did: did,
    })
  );
}

app.config.errorHandler = function (err, vm, info) {
  // 处理错误，例如记录日志
  console.error('Vue error:', err, info);
};
app.use(VueKonva);
app.use(router);
app.mount('#app');
